import { css } from 'lit';

export const imageStyles = css`
  :host {
    display: flex;
    justify-content: center;
    width: 100%;
    height: auto;
  }
  
  * {
    box-sizing: border-box;
  }
    
  .image-container {
    position: relative;
    width: fit-content;
    height: fit-content;

    ::slotted(img), ::slotted(picture) {
        display: block;
      position: relative;
    }
  }

  .shape {
    position: absolute;
  }

  .fill-yellow {fill:#FFD500;}
  .fill-yellow400 {fill:#FFE040;}
  .fill-yellow400-opacity-75 {fill:#FFE040;fill-opacity:0.75;}
  .fill-yellow600 {fill:#FFC300;}
  .fill-blue {fill:#3868C6;}

  .fill-lightblue400 {fill:#45D9FF;}
  .fill-lightblue400-opacity-75 {fill:#45D9FF;fill-opacity:0.75;}
  .fill-lightblue300-opacity-75 {fill:#A2ECFF;fill-opacity:0.75;}

  .fill-darkblue {fill:#003C6E;}
  .fill-darkblue400 {fill:#3356A3;}
  .fill-darkblue400-opacity-75 {opacity:0.75; fill:#3356A3;}

  .fill-violet {fill:#A483FF;}
  .fill-violet2 {fill:#A080FF;}
  .fill-violet3-opacity-75 {fill:#A180FF;fill-opacity:0.75;}
  .fill-violet500 {fill:#A584FF;}
  .fill-violet500-opacity-75 {fill:#A584FF;fill-opacity:0.75;}
  .violet-stroke {fill:none;stroke:#A584FF;stroke-width:2;}
`;
